import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  mandate_type: number;
  category: string;
  primary_division?: number;
  primary_team?: number;
  /** Ids of Divisions/Teams the record is also shared into. */
  additional_divisions?: number[];
  additional_teams?: number[];
}
export const useCreateMandateForChecks = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(`${env.verifyServiceUrl}individual/mandate/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
